import React from "react";
import { IngestionJob } from "../../api/ingestionJob";
import { AddPurchaseOrdersStep } from "./add-purchase-orders-step";

export const PurchaseOrdersWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver }) => {

    const isAddPurchaseOrdersStepEnabled = () => {
        if (isEdit) return false;

        return workflowStep === 1;
    }

    const isConfirmPurchaseOrdersDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;

        return workflowStep === 2;
    }

    const isInblockedPurchaseOrdersDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;

        return workflowStep === 3;
    }

    return <>
        {isAddPurchaseOrdersStepEnabled() && <AddPurchaseOrdersStep job={job} next={next} back={back} cancel={cancel} />}
        {/* { isConfirmPurchaseOrdersDataStepEnabled() && <ConfirmPurchaseOrdersDataStep isEdit={ isEdit } jobId={ job.id } next={ next } cancel={ cancel } startOver={ startOver } /> }
        { isInblockedPurchaseOrdersDataStepEnabled() && <InblockedPurchaseOrdersDataStep jobId={ job.id } back={ back } /> } */}
    </>
}
